import React, { useReducer } from 'react';
import { Switch } from 'react-router-dom';

import NewsContext from '../../context/news-context';
import newsReducer from '../../reducers/news-reducer';
import NewsHeader from './NewsHeader'
import NewsDetail from './NewsDetail'
import News from './News'
import NewsSearch from './NewsSearch'
import PrivateRoute from '../../routers/PrivateRoute'

const NewsRoute = () => {
    const [newsContext, dispatch] = useReducer(newsReducer);

    return (
        <NewsContext.Provider value={{ newsContext, dispatch }}>
            <NewsHeader />
            <Switch>
                <PrivateRoute path="/News" children={<News />} exact={true} />
                <PrivateRoute path="/NewsDetail" children={<NewsDetail/>} exact={true} />
                <PrivateRoute path="/NewsSearch" children={<NewsSearch />} />
            </Switch>

        </NewsContext.Provider>
    )
}

export default NewsRoute;